import React from "react";
import {useTranslation} from "react-i18next";


function Nav() {
    const {t} = useTranslation()
    return (
        <div className="nav row my-3 align-items-center">
            <div className="col-2">
                <img className="logo" src={require("../img/logo.png")} alt="Медгенетика.рф" />
            </div>
            <div className="col-10">
                <h2 className="mb-0">{t('top_biocollection_name')}</h2>
            </div>
        </div>
    )
}

export default Nav;